import axiosPost from "../axiosPost";

export const GateUsuarioGet = async ({
  usuarioApellidos = null,
  usuarioNroDeDocumentoX = null,
  usuarioTieneAcceso = null,
  page = null,
  pageSize = null,
}, credentials) => {
  const body = {
    service: "GateUsuarioGet",
    params: {
      merchantId: credentials?.merchantId,
      usuarioApellidos,
      usuarioNroDeDocumentoX,
      usuarioTieneAcceso,
      page,
      pageSize,
    },
  };

  const result = await axiosPost(body, credentials);

  if (page !== null && pageSize !== null) {
    return {
      result: result.result,
      total: result.status.id,
      status: result.status,
    };
  }

  return result.result;
};
